// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 3px;
  padding: 0;
  display: block;
}
ion-radio-group ion-item {
  background: #ffffff;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
  margin-bottom: 8px;
  --inner-padding-end: 8px;
}
ion-radio-group ion-item:has(ion-radio.radio-checked) {
  border-color: var(--ion-color-tertiary);
}
ion-radio-group ion-item:has(ion-radio.radio-checked) ion-label {
  color: var(--ion-color-tertiary) !important;
}

ion-radio {
  --color: #6b6b6b;
  --color-checked: var(--ion-color-tertiary);
  --border-width: 1px;
  --size: 18px;
}
ion-radio.radio-checked::part(mark) {
  transform: scale3d(1.1, 1.1, 1);
}

.price {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.78px;
  letter-spacing: 0.01em;
  text-align: right;
  margin-inline-start: 4px;
  text-align: end;
  color: var(--color-black);
}

ion-label {
  display: block;
  font-family: AppFont !important;
  font-size: 14px !important;
  line-height: 17.78px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #1d1d1b !important;
  text-transform: uppercase;
}

.measurement {
  font-size: 12px;
}

ion-icon {
  color: #6b6b6b;
  height: 18px;
  width: 18px;
}

app-tag {
  display: inline-block;
}

.selected {
  font-family: AppFont, sans-serif;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-single/article-option-group-single.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AACD;AACC;EACC,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;AACF;AAEC;EACC,uCAAA;AAAF;AAGC;EACC,2CAAA;AADF;;AAKA;EACC,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;AAFD;AAIC;EACC,+BAAA;AAFF;;AAMA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EAEA,wBAAA;EACA,eAAA;EACA,yBAAA;AAJD;;AAOA;EACC,cAAA;EACA,+BAAA;EACA,0BAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AAJD;;AAMA;EACC,eAAA;AAHD;;AAKA;EACC,cAAA;EACA,YAAA;EACA,WAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,gCAAA;AAFD;;AAKA;EACC,eAAA;AAFD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 3px;\n\tpadding: 0;\n\tdisplay: block;\n\n\tion-item {\n\t\tbackground: #ffffff;\n\t\tborder: 1px solid #cfcfcf;\n\t\tborder-radius: 3px;\n\t\tmargin-bottom: 8px;\n\t\t--inner-padding-end: 8px;\n\t}\n\n\tion-item:has(ion-radio.radio-checked) {\n\t\tborder-color: var(--ion-color-tertiary);\n\t}\n\n\tion-item:has(ion-radio.radio-checked) ion-label {\n\t\tcolor: var(--ion-color-tertiary) !important;\n\t}\n}\n\nion-radio {\n\t--color: #6b6b6b;\n\t--color-checked: var(--ion-color-tertiary);\n\t--border-width: 1px;\n\t--size: 18px;\n\n\t&.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.1, 1.1, 1);\n\t}\n}\n\n.price {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 17.78px;\n\tletter-spacing: 0.01em;\n\ttext-align: right;\n\n\tmargin-inline-start: 4px;\n\ttext-align: end;\n\tcolor: var(--color-black);\n}\n\nion-label {\n\tdisplay: block;\n\tfont-family: AppFont !important;\n\tfont-size: 14px !important;\n\tline-height: 17.78px;\n\tletter-spacing: 0.01em;\n\ttext-align: left;\n\tcolor: #1d1d1b !important;\n\ttext-transform: uppercase;\n}\n.measurement {\n\tfont-size: 12px;\n}\nion-icon {\n\tcolor: #6b6b6b;\n\theight: 18px;\n\twidth: 18px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.selected {\n\tfont-family: AppFont, sans-serif;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
